export default function Investors() {
  return (
    <section
      id="vision"
      data-testid="investors"
      className="py-32 md:py-48 bg-ink-deep text-cream relative overflow-hidden"
    >
      <div className="grain absolute inset-0 opacity-30 pointer-events-none" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-12 gap-6 mb-20 md:mb-32">
          <div className="col-span-12 md:col-span-8">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
              ◊ Visión 2030
            </p>
            <h2 className="mt-6 font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter">
              No vamos a <span className="italic">cerrar Facebook</span>.<br />
              Vamos a hacerlo <span className="text-coral italic">irrelevante</span>.
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 md:pt-10 text-lg text-cream/75 leading-relaxed">
            Capturar el 50% del mercado actual de Facebook para 2030. Construido sobre todo lo que la gente ya no soporta — y todo lo que finalmente desea.
          </p>
        </div>

        {/* Massive metrics */}
        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-cream/15">
          {[
            { k: "50%", v: "del mercado de Facebook capturado en 2030", note: "objetivo estratégico" },
            { k: "1.5B", v: "usuarios activos proyectados", note: "horizonte 5 años" },
            { k: "$28B", v: "GMV anual del marketplace", note: "modelo financiero" },
          ].map((m, i) => (
            <div
              key={m.v}
              className={`p-8 md:p-12 border-b border-cream/15 ${i < 2 ? "md:border-r border-cream/15" : ""}`}
            >
              <div className="font-serif text-7xl md:text-8xl lg:text-9xl leading-[0.85] tracking-tighter text-coral">
                {m.k}
              </div>
              <p className="mt-6 text-base text-cream/85 max-w-xs leading-relaxed">
                {m.v}
              </p>
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-cream/45">
                {m.note}
              </p>
            </div>
          ))}
        </div>

        {/* Business model row */}
        <div className="mt-24 md:mt-32 grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
              modelo de negocio
            </p>
            <p className="mt-4 font-serif text-3xl md:text-4xl leading-tight">
              Siete fuentes,<br />una misma <span className="italic">tesis</span>.
            </p>
          </div>
          <div className="col-span-12 md:col-span-9 grid grid-cols-2 md:grid-cols-4 gap-px bg-cream/15 rounded-xl overflow-hidden">
            {[
              "Publicidad premium",
              "Membresías PRO",
              "Comisión marketplace",
              "Herramientas empresas",
              "Verificación premium",
              "IA avanzada paga",
              "Promoción de contenido",
              "API & datos agregados",
            ].map((m, i) => (
              <div
                key={m}
                className="bg-ink-deep p-6 hover:bg-cream/[0.03] transition-colors duration-500"
              >
                <span className="font-mono text-[10px] text-coral">{String(i + 1).padStart(2, "0")}</span>
                <p className="mt-3 text-sm text-cream/90">{m}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-20 md:mt-28 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-cream/15 pt-10">
          <p className="font-serif text-2xl md:text-3xl max-w-2xl text-cream">
            Buscamos socios estratégicos para la <span className="italic text-coral">Series A</span> y arquitectos de producto para construirla.
          </p>
          <a
            href="mailto:investors@ovamx.com"
            data-testid="investors-cta"
            className="inline-flex items-center gap-2 border border-cream/30 text-cream rounded-full px-7 py-3.5 text-sm hover:bg-coral hover:border-coral transition-all duration-500"
          >
            Hablemos
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M7 17L17 7M17 7H8M17 7v9" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
